import { render } from "./MessageGroupListItem.vue?vue&type=template&id=43289ee5"
import script from "./MessageGroupListItem.vue?vue&type=script&lang=js"
export * from "./MessageGroupListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__